import React from 'react';
import styles from './PatientTable.module.css';
import type { PatientRow } from '../../pages/Ai_Hub/VoiceDataEntry/AIVoiceDataEntry.types';

interface PatientTableProps {
  rows: PatientRow[];
  loading?: boolean;
  error?: string | null;
  onSelect: (patient: PatientRow) => void;
}

const getInitials = (name: string) => {
  if (!name || name === '-') return '?';
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || '?';
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
};

const PatientTable: React.FC<PatientTableProps> = ({
  rows,
  loading,
  error,
  onSelect,
}) => {
  return (
    <div className={styles.tableWrapper}>
      <div className={styles.tableHeader}>
        <div>REGISTRATION DATE</div>
        <div>PATIENT NAME</div>
        <div>PARTNER NAME</div>
        <div>MOBILE</div>
        <div>DOCTOR</div>
        <div>FIRST VISIT</div>
        <div>STATUS</div>
      </div>

      {loading ? (
        <div className={styles.stateBox}>Loading...</div>
      ) : error ? (
        <div className={styles.stateBox}>{error}</div>
      ) : rows.length === 0 ? (
        <div className={styles.stateBox}>No patients found</div>
      ) : (
        rows.map((row) => (
          <button
            key={row.id}
            type="button"
            className={styles.tableRow}
            onClick={() => onSelect(row)}
          >
            <div className={styles.cell}>{row.registrationDate}</div>

            <div className={styles.cell}>
              <div className={styles.nameBlock}>
                {row.avatar ? (
                  <img src={row.avatar} alt={row.name} className={styles.avatar} />
                ) : (
                  <div className={styles.avatarFallback}>{getInitials(row.name)}</div>
                )}
                <span className={styles.nameText}>{row.name}</span>
              </div>
            </div>

            <div className={styles.cell}>
              <div className={styles.nameBlock}>
                {row.partnerAvatar ? (
                  <img
                    src={row.partnerAvatar}
                    alt={row.partnerName}
                    className={styles.avatar}
                  />
                ) : (
                  <div className={styles.avatarFallback}>
                    {getInitials(row.partnerName)}
                  </div>
                )}
                <span className={styles.nameText}>{row.partnerName}</span>
              </div>
            </div>

            <div className={styles.cell}>{row.mobile}</div>
            <div className={styles.cell}>{row.doctor}</div>
            <div className={`${styles.cell} ${styles.reasonCell}`} title={row.reasonForVisit}>
              {row.reasonForVisit}
            </div>
            <div className={styles.cell}>
              <span className={styles.statusPill}>{row.status}</span>
            </div>
          </button>
        ))
      )}
    </div>
  );
};

export default PatientTable;